import { gql } from '@apollo/client'

import * as f from '../../components/BPMTable/BPMInputs'
import {
    DataMapper,
    TableFieldDescription,
    StatusComponentCreator,
    BooleanExcelDisplayCreator,
} from '../../components/BPMTable/TableMapperCreator'

const tableQuery = gql`
    query BayphoneUsers(
        $orderField:String,
        $first:Int,
        $last:Int,
        $after:String,
        $before:String,
        $enterpriseId:String,
        $email:String,
        $firstName:String,
        $lastName:String,
        $sales:Boolean,
        $isActive:Boolean,
    ) {
        bayphoneUsers(
            orderField:$orderField,
            first:$first,
            last:$last,
            after:$after,
            before:$before,
            enterpriseId:$enterpriseId,
            email:$email,
            firstName:$firstName,
            lastName:$lastName,
            sales:$sales,
            isActive:$isActive
        ) {
            edges {
                node {
                    id
                    sales
                    user {
                        id
                        enterpriseId
                        email
                        isActive
                        dateHired
                        firstName
                        lastName
                    }
                    isActive
                }
            }
            count
            pageInfo {
                hasNextPage
                startCursor
                endCursor
            }
        }
    }
`

const editMutator = gql`
    mutation editBayphoneUserMutation(
        $id:String!,
        $user:String!,
        $sales:Boolean,
        $isActive:Boolean,
    ) {
        editBayphoneUser(
            id:$id,
            user:$user,
            sales:$sales,
            isActive:$isActive,
        ) {
            bayphoneUser {
                id
            }   
        }
    }
`

const newMutator = gql`
    mutation createBayphoneUserMutation(
        $user:String!,
        $sales:Boolean,
        $isActive:Boolean,
    ) {
        createBayphoneUser(
            user:$user,
            sales:$sales,
            isActive:$isActive,
        ) {
            bayphoneUser {
                id
            }
        }
    }
`

const deleteMutator = gql`
    mutation changeBayphoneUserMutation($ids: [String!], $allRecords: Boolean, $filters: String) {
        changeBayphoneUser(ids: $ids, allRecords: $allRecords, filters: $filters) {
            bayphoneUser {
                id
            }
        }
    }
`

const unitQuery = `
    bayphoneUser(id: $id) {
        id
        sales
        user {
            id
            enterpriseId
            email
            isActive
            dateHired
            firstName
            lastName
        }
        isActive
    }
`

const bayphoneUserQueries = { tableQuery, editMutator, newMutator, deleteMutator, unitQuery }

const getBayphoneUserTableDefinitions = (useMinimalTable) => { 
    const fields = [
        new TableFieldDescription(
            'enterpriseId',
            new DataMapper("user.enterpriseId"),
            new f.FilterDescription(new f.TextFilter("enterpriseId")),
            { label: 'Enterprise Id' }
        ),
        new TableFieldDescription(
            'email',
            new DataMapper("user.email"),
            new f.FilterDescription(new f.TextFilter("email")),
            { label: 'Email' }
        ),
        new TableFieldDescription(
            'firstName',
            new DataMapper("user.firstName"),
            new f.FilterDescription(new f.TextFilter("firstName")),
            { label: 'First Name' }
        ),
        new TableFieldDescription(
            'lastName',
            new DataMapper("user.lastName"),
            new f.FilterDescription(new f.TextFilter("lastName")),
            { label: 'Last Name' }
        ),
    ]

    if (!useMinimalTable) {
        fields.push(
            new TableFieldDescription(
                'sales',
                new DataMapper("sales"),
                new f.FilterDescription(new f.BooleanFilter("sales", "Yes", "No")),
                { 
                    label: 'Sales', 
                    componentCreator: new StatusComponentCreator(), 
                    excelDisplay: new BooleanExcelDisplayCreator() 
                }
            ),
            new TableFieldDescription(
                'isActive',
                new DataMapper("isActive"),
                new f.FilterDescription(new f.BooleanFilter("isActive", "Yes", "No")),
                { 
                    label: 'Is Active',
                    componentCreator: new StatusComponentCreator(), 
                    excelDisplay: new BooleanExcelDisplayCreator() 
                }
            ),
        )
    }

    return fields
}

export { bayphoneUserQueries, getBayphoneUserTableDefinitions }